import React, {useEffect, useState} from "react";
import {Button, Loader} from 'semantic-ui-react'
import {useNavigate} from "react-router";
import {SuccessMessage} from "../_core/SuccessMessage";

export default function ZohoGrabberContact(props) {
    const [data, setData] = useState({grabber: '', loading: false});
    const navigate = useNavigate()

    const handleSubmit = async () => {
        const url = API_URL + '/api/private/tanker/v1/zoho/grabber/contacts/fetch'

        setData({loading: true, grabber: ''});

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({grabber: data, loading: false});
            });
    }

    useEffect(() => {
        document.title = 'Grab contacts'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
    }, [])

    const loading = data.loading;
    const message = data.grabber.message;

    return (
        <div>
            <h2>Contact </h2>
            <p>Fetches all contacts from Zoho</p>
            <Button onClick={handleSubmit}>Submit</Button>
            {loading ? <Loader active inline='centered'></Loader> : ''}
            {typeof message !== 'undefined' ? <SuccessMessage header="Success" message={message}/> : ''}
        </div>
    )
}


